import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class IframeService {
  public isInIframe: boolean;
  constructor() {
    this.isInIframe = window !== window.parent;
  }
}
